import axios from "axios"
const base = "/api/open-house"
const options = () => ({ headers: { Authorization: localStorage.getItem("token") } })
export default {
  openHouse: {
    load: targetStudioId => axios.get(base, { ...options(), params: { targetStudioId } }).then(response => response.data),
    availability: () => axios.get(`${base}/availability`, options()).then(response => response.data),
    save: (action, data) => axios.post(`${base}/${action}`, data, options()).then(response => response.data),
  },
}
